const baseUrl = 'https://teleport.withgoogle.com';

export const environment = {
  production: false,
  footerLinks: {
    google: 'https://www.google.com/',
    googleAbout: 'https://about.google/',
    privacy: 'https://policies.google.com/privacy',
    policies: 'https://policies.google.com/terms',
    help: baseUrl + '/spravka/nachalo-raboty/startovaya-stranica',
    support: baseUrl + '/spravka/napisat-v-sluzbu-podderzki',
    terms: baseUrl + '/spravka/obshchaya-informaciya/usloviya-ispolzovaniya-teleporta',
    googleProducts: 'https://ads.google.com/intl/en/home/',
    mcc: 'https://support.google.com/google-ads/answer/6139186?hl=en&ref_topic=7554904',
  },
  headerLinks: {
    googleAds: 'https://ads.google.com/intl/en/home/',
  },
};
